import { Button, CssBaseline, Drawer, Hidden, makeStyles, useMediaQuery, useTheme, Box } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { Wizard } from './Wizard';
import { Chat } from '../Chat';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { stepState } from '../RecoilState';
import { CLOSE_CHAT, openChatState } from 'pages/CustomerBooking';
import { SquarePopUp } from '../AppPopup/SquarePopup';
import { useUserState } from 'services/authentication.service';
import { useTrackEvent } from 'util/trackEvent';
import { Alert, AlertTitle } from '@material-ui/lab';
import { throwError401 } from 'services/test.service';

export const DRAWER_WIDTH = 240;

const useStyles = makeStyles((theme) => {
  return {
    sidebarRoot: {
      display: 'flex',
      height: '100%',
      width: '100%',
    },
    drawer: {
      [theme.breakpoints.up('md')]: {
        width: DRAWER_WIDTH,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up('md')]: {
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        marginLeft: DRAWER_WIDTH,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      display: 'flex',

      width: DRAWER_WIDTH,
    },
    content: {
      [theme.breakpoints.down('sm')]: {
        marginLeft: DRAWER_WIDTH,
      },
      overflowX: 'hidden',
      flexGrow: 1,
      scrollbarGutter: "stable both-edges",
    },
    padded: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    logout: {
      bottom: 0
    }
  }
})

const Sidebar = ({ current = 0, serviceId, window, children, ...props }) => {
  const classes = useStyles()

  const { getIdentity, user, getUser, logout } = useUserState()

  const supportRef = React.useRef(null)

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const setChatOpen = useSetRecoilState(openChatState);
  const chatOpen = useRecoilValue(openChatState);

  const currentStep = useRecoilValue(stepState)
  const trackEvent = useTrackEvent()

  return (
    <div className={classes.sidebarRoot}>
      <CssBaseline />
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden xsDown implementation="js">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            <Wizard onLogout={() => {
              logout(serviceId, {})
            }} isMobile={false} serviceId={serviceId} current={currentStep} />
            {/* {(chatOpen === CLOSE_CHAT) && <SquarePopUp />} */}
            <Box flexGrow={.5}
            >
              <Alert severity="info" variant='outlined'>
                All dates and times are in +8 UTC or PHT unless stated otherwise
              </Alert>
            </Box>
            {process.env.REACT_APP_ENVIRONMENT==='dev' && (
              <Box flexGrow={.5}>
                <Alert severity="warning" variant='outlined'>
                  <AlertTitle>Dev Only:</AlertTitle>
                  <Button onClick={async()=>{
                    await throwError401()
                  }}>Throw Test Error </Button>
                </Alert>
              </Box>
            )}
            <Box flexGrow={.5}>
              <Button fullWidth className={classes.logout} variant='text' onClick={() => {
                trackEvent('Sidebar click Logout', { booking_id: serviceId })
                logout(serviceId)
              }
              }>Logout</Button>
            </Box>

          </Drawer>
        </Hidden>
      </nav>

      <main className={classes.content}>
        {children}
      </main>
    </div>
  )
}

export { Sidebar };
